<template>
    <b-card header="Agency Overview">
        <div class="row block agency-details">
            <div
                class="col col-auto me-4"
                v-if="hasPermission('ViewAgencyDetails')">
                <dl class="agency-definition-list">
                    <dt>Address:</dt>
                    <dd
                        v-if="data?.loc_street && data?.loc_town">
                        <div>{{ data?.loc_street }}</div>
                        <div>{{ data?.loc_town }}, {{ data?.loc_state }}</div>
                        <div>{{ data?.loc_zip }}</div>
                    </dd>
                    <dd
                        v-else-if="data?.mail_street && data?.mail_town">
                        <div>{{ data?.mail_street }}</div>
                        <div>{{ data?.mail_town }}, {{ data?.mail_state }}</div>
                        <div>{{ data?.mail_zip }}</div>
                    </dd>
                </dl>
            </div>
            <div
                v-if="population && population?.year > 0"
                class="col col-auto me-4 mt-4">
                <dl class="agency-definition-list">
                    <dt>{{ population?.year }} Population:</dt>
                    <dd>{{ formatNumber(population?.employee_population) }}</dd>
                </dl>
            </div>

            <div
                class="col col-auto staffing me-4 mt-4"
                v-if="staffing &&
                    (staffing.year > 0 ||
                        staffing.sworn_in_male ||
                        staffing.sworn_in_female ||
                        staffing.civilian_male ||
                        staffing.civilian_female)">
                <dl class="agency-definition-list">
                    <dt v-if="staffing.year > 0">{{ staffing.year }} Employee Count</dt>
                    <template v-if="staffing.year > 0">
                        <dd v-if="staffing.sworn_in_male">
                            <span class="definition-label">Sworn-in Male:</span> {{ formatNumber(staffing.sworn_in_male) }}
                        </dd>
                        <dd v-if="staffing.sworn_in_female">
                            <span class="definition-label">Sworn-in Female:</span> {{ formatNumber(staffing.sworn_in_female) }}
                        </dd>
                        <dd v-if="staffing.civilian_male">
                            <span class="definition-label">Civilian Male:</span> {{ formatNumber(staffing.civilian_male) }}
                        </dd>
                        <dd v-if="staffing.civilian_female">
                            <span class="definition-label">Civilian Female:</span> {{ formatNumber(staffing.civilian_female) }}
                        </dd>
                    </template>
                </dl>
            </div>
        </div>
    </b-card>

    <b-card
        header="Agency Contacts"
        v-if="hasPermission('ViewAgencyContacts') && hasContacts">
        <div class="row block contacts">
            <agency-overview-contact
                :title="data?.admin_title"
                :name="data?.admin_name"
                :email="data?.admin_email"
                :phone="data?.admin_phone"
                :fax="data?.admin_fax" />
            <agency-overview-contact
                :title="data?.ucr_title"
                :name="data?.ucr_name"
                :email="data?.ucr_email"
                :phone="data?.ucr_phone"
                :fax="data?.ucr_fax" />
            <agency-overview-contact
                :title="data?.comm_title"
                :name="data?.comm_name"
                :email="data?.comm_email"
                :phone="data?.comm_phone"
                :fax="data?.comm_fax" />
        </div>
    </b-card>
</template>
<script setup lang="ts">
import {BCard} from "./../Misc";
import {formatNumber} from "@/utils";
import AgencyOverviewContact from "./AgencyOverviewContact.vue";
const props = defineProps({
    ori: {
        type: String,
        default: null,
    },
});

import {computed, watch} from "vue";
import {useOriStore} from "@/stores/oriStore";
import hasPermission from "@/composable/permissionHelper";
import {storeToRefs} from "pinia";

const oriStore = useOriStore();
var {population, staffing} = storeToRefs(useOriStore());

const data = computed(() => {
    return oriStore.ori;
});

const hasContacts = computed(() => {
    return data.value?.admin_name || data.value?.ucr_name || data.value?.comm_name;
});

watch(props, async () => {
    await oriStore.getPopulation(props.ori);
    await oriStore.getStaffing(props.ori);
});
</script>
<style lang="scss">
dt {
    float: left;
    clear: left;
    padding-right: 5px;
    font-weight: bold;
}

dd {
    margin-left: 0px;
}

.agency-definition-list {
    margin-bottom: 1rem;
    display: block;
    width: 100%;
}

.agency-definition-list dt {
    float: left;
    clear: left;
    padding-right: 5px;
    font-weight: bold;
}

.agency-definition-list dd {
    display: block;
    margin-left: 0;
    margin-bottom: 0.25rem;
}

.definition-label {
    font-weight: bold;
    display: inline-block;
    min-width: 110px;
}

.agency-details {
    .staffing {
        span {
            &.h5 {
                display: inline-block;
                width: 110px;
            }
        }
    }
}
.contacts {
    span {
        &.h5 {
            display: inline-block;
            width: 45px;
        }
    }
}
</style>
